"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineData = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineData = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            return config;
        }
        case "HOTEL": {
            const config = latest_version.config;
            return config;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            return config;
        }
        case "EXCURSION": {
            const config = latest_version.config;
            return config;
        }
        case "CUSTOM": {
            const config = latest_version.config;
            return config;
        }
    }
};
exports.getOrderLineData = getOrderLineData;
